/**
 * Things you can put in your body on a shift.
 *
 * Four rows, one rule. A vape pen, a joint, a coffee and whatever is left in
 * the break room all go through the same system; what separates them is
 * numbers, not code. Coffee and food are in here with an `impairment` of zero,
 * which is the honest way to say that eating something on shift is the same
 * kind of act as smoking something — it takes a moment, it has a duration, and
 * somebody may be watching you do it.
 *
 *   onset       seconds from taking it to full effect
 *   hold        seconds at full effect
 *   fade        seconds coming down
 *
 * Those seconds are real ones, because the bar runs on the body's clock. At the
 * pace the shift clock runs they work out at about a minute of shift each,
 * which is what they were tuned against: a pen is twenty-odd minutes of your
 * shift and a joint is the better part of an hour. Tuned in real seconds and
 * read in shift minutes is a trap worth naming — the first pass had a joint
 * lasting four game hours and a smell that expired before the effect did.
 *   impairment  0..1 at full effect
 *   alert       0..1 at full effect. The other direction.
 *   scent       how strongly it clings, and for how many game minutes
 *   tell        an optional thing anyone close can notice while it is on
 *
 * The two that matter are the pen and the joint, and the difference between
 * them is the whole design of the rule: the pen is the work tool — on in
 * seconds, off in a minute, no smell, small effect — and the joint is the
 * commitment, worth twice as much in both directions, and it stays on your
 * uniform for the better part of an hour after it has worn off.
 */
export const CONSUMABLES = {
  pen: {
    id: 'pen',
    name: 'Vape Pen',
    verb: 'Hit the pen',
    onset: 1.5,
    hold: 14,
    fade: 10,
    impairment: 0.5,
    alert: 0,
    scent: null,
    tell: 'holding your breath',
  },
  joint: {
    id: 'joint',
    name: 'Joint',
    verb: 'Smoke it',
    onset: 4,
    hold: 34,
    fade: 20,
    impairment: 0.85,
    alert: 0,
    /** Clings to the uniform. The locker room is the answer, not time. */
    /** Game minutes, and comfortably longer than the effect it outlives. */
    scent: { strength: 1, minutes: 100 },
    tell: 'red-eyed',
  },
  coffee: {
    id: 'coffee',
    name: 'Coffee',
    verb: 'Drink it',
    onset: 8,
    hold: 120,
    fade: 60,
    impairment: 0,
    alert: 0.7,
    scent: null,
    tell: null,
  },
  meal: {
    id: 'meal',
    name: 'Staff Meal',
    verb: 'Eat',
    onset: 10,
    hold: 200,
    fade: 90,
    impairment: 0,
    alert: 0.35,
    scent: null,
    tell: null,
  },
};

export const consumableList = () => Object.values(CONSUMABLES);
